{
  "recommendationAccepted": null,
  "numberOfDocumentsRequested": 0,
  "setCompletionDateForEmail": "",
  "opportunityOwnerTextForEmail": "John Smith",
  "ownerEmailAddress": "john.smith@mojomortgages.com",
  "mipIssuedToCustomer": true,
  "amount": null,
  "stageName": "Nurture",
  "opportunityRecordType1": "PurchaseOpportunity",
  "currentExperiments": "foobar1;quubar2;zuubaz3",
  "property": {
    "firstLineAddress": "45 Sample Street",
    "value": 285000
  }
}